import React from 'react';

const Amenitiespopup = () => {
  return (
    <div className="p-6 text-gray-800">
      <div className="text-4xl mb-4 text-[#3D6643]">🎁</div>
      <h2 className="text-2xl font-bold text-[#3D6643] mb-4">Amenities Management</h2>
      <p className="text-sm mb-4">
        Attract more guests by showcasing the best features your villa has to offer. Manage amenities with ease:
      </p>

      <ul className="list-disc list-inside text-sm mb-4 space-y-2">
        <li><strong>Custom Amenities:</strong> Add unique features like private pools, BBQ pits, sea view, etc.</li>
        <li><strong>Photo Uploads:</strong> Upload photos for each amenity to visually highlight what you offer.</li>
        <li><strong>Category Tags:</strong> Organize amenities by categories (e.g., Essentials, Luxury, Entertainment).</li>
        <li><strong>Status Control:</strong> Enable or disable specific amenities as needed (e.g., seasonal access).</li>
        <li><strong>Instant Updates:</strong> Any change reflects instantly on the villa's booking page.</li>
      </ul>

      <p className="text-sm">
        Use amenities as your selling point and provide guests with a clear picture of the villa experience you offer.
      </p>
    </div>
  );
};

export default Amenitiespopup;
